<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar :background-color="sidebarBackground" title="Apolo">
      <template slot-scope="props" slot="links">
        <!-- <user-menu></user-menu> -->
        <sidebar-item
          v-if="can_view_menu_dashboard"
          :link="{
            name: 'Dashboard',
            icon: 'now-ui-icons business_chart-pie-36',
            path: '/dashboard',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="can_view_metrics"
          :link="{
            name: 'Métricas',
            icon: 'now-ui-icons business_chart-bar-32',
            path: '/metrics',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="can_view_menu_dimensionar"
          :link="{
            name: 'Dimensionar',
            icon: 'now-ui-icons shopping_basket',
            path: '/dimension',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="can_view_menu_orcamentos"
          :link="{
            name: 'Orçamentos',
            icon: 'now-ui-icons education_paper',
            path: '/budgets',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="can_view_menu_pedidos"
          :link="{
            name: 'Pedidos',
            icon: 'now-ui-icons shopping_box',
            path: '/orders',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="can_view_menu_stringsizer"
          :link="{
            name: 'StringSizer',
            icon: 'now-ui-icons business_bulb-63',
            path: '/string-sizer',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="can_view_menu_cadastrar_cliente"
          :link="{
            name: 'Cadastrar Cliente',
            icon: 'now-ui-icons users_single-02',
            path: '/register-client',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="!is_customer"
          :link="{
            name: 'Configurações',
            icon: 'now-ui-icons ui-1_settings-gear-63',
          }"
        >
          <sidebar-item
            v-if="can_view_menu_produtos"
            :link="{
              name: 'Produtos',
              icon: 'now-ui-icons design_app',
              path: '/settings/products',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_marcas"
            :link="{
              name: 'Marcas',
              icon: 'now-ui-icons design_app',
              path: '/settings/brands',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_usuarios"
            :link="{
              name: 'Usuários',
              icon: 'now-ui-icons design_app',
              path: '/settings/users',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_clientes"
            :link="{
              name: 'Clientes',
              icon: 'now-ui-icons design_app',
              path: '/settings/customers',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_cargos"
            :link="{
              name: 'Cargos',
              icon: 'now-ui-icons design_app',
              path: '/settings/roles',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_permissoes"
            :link="{
              name: 'Permissões',
              icon: 'now-ui-icons design_app',
              path: '/settings/permissions',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_frete"
            :link="{
              name: 'Frete',
              icon: 'now-ui-icons design_app',
              path: '/shipping',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_fornecedores"
            :link="{
              name: 'Fornecedores',
              icon: 'now-ui-icons design_app',
              path: '/settings/providers',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_banner"
            :link="{
              name: 'Banner',
              icon: 'now-ui-icons design_app',
              path: '/settings/banner',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="is_admin"
            :link="{
              name: 'Quadros de avisos',
              icon: 'now-ui-icons design_app',
              path: '/settings/message-board',
            }"
          >
          </sidebar-item>
          <sidebar-item
            v-if="can_view_menu_categorias"
            :link="{
              name: 'Categorias de produtos',
              icon: 'now-ui-icons design_app',
              path: '/settings/product-categories',
            }"
          >
          </sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <!-- <sidebar-share
        :color.sync="sidebarBackground"
        :fixed-navbar.sync="fixedNavbar"
        :sidebarMini.sync="sidebarMini"
        style="cursor: pointer"
      >
      </sidebar-share> -->
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./components/TopNavbar.vue";
import ContentFooter from "./components/ContentFooter.vue";
import UserMenu from "./components/Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import Vuex from "vuex";
import SidebarShare from "./components/Extra/SidebarSharePlugin";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
    ZoomCenterTransition,
    SidebarShare,
  },
  data() {
    return {
      roles: [],
      sidebarBackground: "black",
      fixedNavbar: false,
      sidebarMini: false,
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
        let text = this.$sidebar.isMinimized ? "activated" : "deactivated";
        this.$notify({ type: "info", message: `Sidebar mini ${text}...` });
      }
    },
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
    // this.initScrollbar(), this.$store.dispatch("profile/me");
  },
  computed: {
    // ...Vuex.mapState({
    //   me: (state) => state.profile.me,
    // }),
  },
  watch: {
    // me: {
    //   handler: function (val) {
    //     this.roles = val.roles.map((r) => r.name);
    //   },
    //   deep: true,
    // },
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
